<div class="d-flex flex-column py-8 text-center position-relative h-75">
  <div class=" d-flex justify-content-center">
    <ng-lottie class="top-0 z-index-3" [options]="options"></ng-lottie>
  </div>

  <div class="text-primary fs-2hx">
    {{title}}
  </div>
</div>
